import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Device } from 'src/app/classes/device';
import { DashboardService } from '../dashboard.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MustMatch } from 'src/app/data-service/must-match.validator';

@Component({
  selector: 'app-add-device',
  templateUrl: './add-device.component.html',
  styleUrls: ['./add-device.component.scss']
})
export class AddDeviceComponent implements OnInit {

  private ResponseVerifiedAddDevice$: Subject<any> = new Subject();
  private ResponseVerifiedUpdateDevice$: Subject<any> = new Subject();
  private ResponseVerifiedGetDeviceInfo$: Subject<any> = new Subject();
  private ResponseVerifiedGetAllEpcUser$: Subject<any> = new Subject();

  public uploadFlagSpinner: any;
  deviceInfo = new Device();
  adddeviceForm: FormGroup;
  message: string;
  dev_name: any;
  isEditing: any;
  deviceId: any;
  editDeviceObject: any = {};
  dataObject: any = [];
  editSerial_No: string;
  editDev_Name: any;
  editEpcId: any;
  deviceType: any;
  editCompany_Name: any;
  editMake_Id: any;
  editMax_Param_Count: any;
  editInverter_Capacity: any;
  public adminEpcUserList: any;
  role: any;
  roleName: string;
  search: any = '';
  page = 1;
  limit: any = 0;
  offset: any = 0;
  srcString: any;
  editRegistered_By: any;
  getEpcObj: any;
  flag: any;

  constructor(private fb: FormBuilder, private router: Router, private route: ActivatedRoute, private dashbord: DashboardService,
    private toastr: ToastrService) {

    this.route.queryParams.subscribe(params => {
      if (params.device_id) {
        this.isEditing = true;
        this.deviceId = params.device_id;
      }
    });
    this.role = localStorage.role;
    if (this.role == '1') {
      this.roleName = 'admin';
    } else if (this.role == '2') {
      this.roleName = 'epc';
    } else if (this.role == '5') {
      this.roleName = 'slave_admin';
    }
  }

  ngOnInit() {
    this.adddeviceForm = this.fb.group({
      // We can set default values by passing in the corresponding value or leave blank if we wish to not set the value. For our example, we’ll default the gender to female.
      dev_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],//[a-zA-Z0-9][a-zA-Z0-9 ]+
    //  serial_no: ['', [Validators.required, Validators.pattern("^[0-9]*$"), Validators.minLength(15), Validators.maxLength(15)]],
      serial_no: ['', [Validators.required, Validators.pattern("^[0-9a-zA-Z]*$"), Validators.minLength(15), Validators.maxLength(15)]],

      // company_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      registered_by: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      epc_id: ['0'],
      confirm_serial_no: ['', Validators.required],
      device_type:['',Validators.required]
    },{
      validator: MustMatch('serial_no', 'confirm_serial_no')
  }
    );

    if (this.isEditing == true) {
      this.getInfoByDeviceId();
    }

    if (this.roleName == 'admin' || this.roleName == 'slave_admin') {
      this.getAllEpcUser(this.search, this.limit, this.offset);
    }

  }
  get f() { return this.adddeviceForm.controls; }


  add_device() {

    var deviceInfo =
    {
      "dev_name": this.adddeviceForm.controls['dev_name'].value,
      // "company_name": this.adddeviceForm.controls['company_name'].value,
      "serial_no": this.adddeviceForm.controls['serial_no'].value,
      "registered_by": this.adddeviceForm.controls['registered_by'].value,
      "epc_id": this.adddeviceForm.controls['epc_id'].value,
      "device_type": this.adddeviceForm.controls['device_type'].value
    }

    this.dashbord.addDevice(deviceInfo)
      .pipe(takeUntil(this.ResponseVerifiedAddDevice$))
      .subscribe(data => {
        if (data.status === true || data.status === 'true') {
          this.toastr.success(data.message);
          this.router.navigate(['/inject-solar/devices']);


        } else if (!data.status) {
          if (data.message == 'Unauthorised or Login Time-out') {
            this.toastr.info(data.message);
            this.router.navigate(["/login"]);

          } else {
            this.toastr.info(data.message);

          }

        }
      },
        err => {
          return console.log(err);
        })
  }
  // getAllEpc() {

  //   this.getEpcObj={
  //     search :"",
  //     limit:0,
  //     offset:0
  //   }
  //   this.dashbord.getAllEpcUser(this.getEpcObj)
  //     .pipe(takeUntil(this.ResponseVerifiedUpdateDevice$))
  //     .subscribe(data => {
  //       if (data.status === true || data.status === 'true') {
  //         this.router.navigate(['/inject-solar/devices']);
  //         this.toastr.success(data.message);

  //       } else if (!data.status) {
  //         if (data.message == 'Unauthorised or Login Time-out') {
  //           this.toastr.info(data.message);
  //           this.router.navigate(["/login"]);

  //         } else {
  //           this.toastr.info(data.message);

  //         }

  //       }
  //     },
  //       err => {
  //         return console.log(err);
  //       })
  // }

  update_device() {

    var deviceInfo =
    {
      "device_id": this.deviceId,
      "dev_name": this.adddeviceForm.controls['dev_name'].value,
      // "company_name": this.adddeviceForm.controls['company_name'].value,
      "serial_no": this.adddeviceForm.controls['serial_no'].value,
      "registered_by": this.adddeviceForm.controls['registered_by'].value,
      "epc_id": this.adddeviceForm.controls['epc_id'].value,
      "device_type": this.adddeviceForm.controls['device_type'].value
    }
    this.dashbord.updateDevice(deviceInfo)
      .pipe(takeUntil(this.ResponseVerifiedUpdateDevice$))
      .subscribe(data => {
        if (data.status === true || data.status === 'true') {
          this.router.navigate(['/inject-solar/devices']);
          this.toastr.success(data.message);

        } else if (!data.status) {
          if (data.message == 'Unauthorised or Login Time-out') {
            this.toastr.info(data.message);
            this.router.navigate(["/login"]);

          } else {
            this.toastr.info(data.message);

          }

        }
      },
        err => {
          return console.log(err);
        })
  }


  getInfoByDeviceId() {

    this.editDeviceObject = {
      device_id: this.deviceId
    };
    this.dashbord.getInfoByDeviceId(this.editDeviceObject)
      .pipe(takeUntil(this.ResponseVerifiedGetDeviceInfo$))
      .subscribe(
        async data => {
          if (data.status) {
            this.editDeviceObject = {};
            this.flag = data.flag;
            if(this.flag == 'true' ||this.flag==true){
              this.adddeviceForm.get('epc_id').disable();
            }else{
               this.adddeviceForm.get('epc_id').enable();
            }

            this.dataObject = data.resultObject;
            this.editSerial_No = data.resultObject[0].serial_no;
            this.editDev_Name = this.dataObject[0].dev_name;
            this.editCompany_Name = this.dataObject[0].company_name;
            this.editRegistered_By = this.dataObject[0].registered_by;
            this.editEpcId = this.dataObject[0].epc_id;
            this.deviceType = this.dataObject[0].device_type;
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(data.message);

            }

          }
          this.adddeviceForm.get('dev_name').setValue(this.editDev_Name);
          this.adddeviceForm.get('serial_no').setValue(this.editSerial_No);
          this.adddeviceForm.get('confirm_serial_no').setValue(this.editSerial_No);
          // this.adddeviceForm.get('company_name').setValue(this.editCompany_Name);
          this.adddeviceForm.get('registered_by').setValue(this.editRegistered_By);
          this.adddeviceForm.get('epc_id').setValue(this.editEpcId);
          this.adddeviceForm.get('device_type').setValue(this.deviceType);
        },
        err => {
          return console.error(err);
        }
      );
  }

  onReset() {
    this.adddeviceForm.reset();
  }


  // Select DropDown of Epc user List for admin add device
  onEpcChange(value: any) {

  }


  // get alladmin epc user list
  getAllEpcUser(search: any, limit: any, offset: any) {

    this.dataObject = {
      search: search,
      limit: limit,
      offset: offset
    }
    this.dashbord.getAllEpcUser(this.dataObject)
      .pipe(takeUntil(this.ResponseVerifiedGetAllEpcUser$))
      .subscribe(
        async data => {
          if (data.status) {
            this.adminEpcUserList = data.resultObject.sort((a: { name: string; },b: { name: any; }) => a.name.localeCompare(b.name));
            // this.adminEpcUserList = data.resultObject;

          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(data.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  ngOnDestroy() {
    this.ResponseVerifiedGetAllEpcUser$.next();
    this.ResponseVerifiedGetAllEpcUser$.complete();

    this.ResponseVerifiedGetDeviceInfo$.next();
    this.ResponseVerifiedGetDeviceInfo$.complete();

    this.ResponseVerifiedUpdateDevice$.next();
    this.ResponseVerifiedUpdateDevice$.complete();

    this.ResponseVerifiedAddDevice$.next();
    this.ResponseVerifiedAddDevice$.complete();
  }
}
